module.exports = __webpack_public_path__ + "media/components/application/PaymentCard/icons/visa-e20c4ccda39d9f0a7907302230f71d41.svg";